export const iconFontAwesomeCommunicationQuoteRight = (
	<i className="fa-solid fa-quote-right"></i>
);
